import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import styled from "styled-components";

const StyledAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    padding: 0px;
    margin: 0;
    border-radius: 5px;
  }
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  &:before {
    background-color: transparent;
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    flex-direction: column;
    margin: 0;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 6px 18px;
    min-height: 36px;
    margin: 0;
  }
`;

export { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary };
